import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "whiteColor fl fs12",
  style: {"margin-left":"5px","margin-bottom":"0"}
}, "調整カレンダーとは", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"width":"98vh","height":"98vh"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalInnerHowToUseCal = _resolveComponent("ModalInnerHowToUseCal")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.Const.started(this.rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                class: "WhatStrictCal fs12 pointer circle_button fr",
                style: {"padding":"5px 8px 3px 8px","border":"1.5px solid #fff","margin-top":"3px","margin-right":"40px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openWhatStrictCal && _ctx.openWhatStrictCal(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/home/help_icon_white.gif.png`),
                  width: "19",
                  class: "fl",
                  style: {"margin-top":"-4px"}
                }, null, 8, _hoisted_3),
                _hoisted_4
              ]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.$getAssetImageUrl(`/assets/home/help_icon_white.gif.png`),
                width: "35",
                style: _normalizeStyle(`${_ctx.isSP ? `position:absolute;right:10px;top:10px;` : `margin-top:-13px;`}`),
                class: "fr pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openWhatStrictCal && _ctx.openWhatStrictCal(...args)))
              }, null, 12, _hoisted_5))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_VueFinalModal, {
      "modal-id": "WhatStrictCalModal",
      "content-class": "ofs modalContent shadowContent rad10 HowToUseModalContent",
      maxWidth: 800,
      maxHeight: 540
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ModalInnerHowToUseCal, {
            onHide: _ctx.hideWhatStrictCal,
            isDev: false,
            devType: null,
            howToUseType: 1
          }, null, 8, ["onHide"])
        ])
      ]),
      _: 1
    })
  ]))
}